<template>
  <div class="bg-gray p-3">
    <div class="row justify-content-center">
      <h5>{{ this.getTitleOfComponent }}</h5>
    </div>
    <ValidationObserver v-slot="{ invalid }">
      <div
          class="form-row align-items-center py-3">
        <NumberInputField
            class="form-group col-lg-4 col-md-12"
            labelText="uurtarief" required
            id="uurtarief"
            step=".01"
            v-model="order.baseHourlyRate"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="order.startDate"
            labelText="order startdatum" required
            vid="hourlyRateStartDate" :crossFieldRules="['same_or_before_field:@hourlyRateEndDate', 'same_or_after_field:@startDate', 'same_or_before_field:@endDate']"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="order.endDate"
            labelText="order einddatum" required
            vid="hourlyRateEndDate" :crossFieldRules="['same_or_after_field:@hourlyRateStartDate', 'same_or_before_field:@endDate']"/>
        <div v-if="isDateConflict" style="color: red;">{{ "Deze datums overlappen met andere:\n " + orderOverlappedPeriods  }}</div>
        <TextInputField class="form-group col-lg-12" labelText="Interne referentie" id="textarea" rows="2" v-model="order.internalMessage" maxlength="255"></TextInputField>
        <TextInputField class="form-group col-lg-12" labelText="Externe referentie" id="textarea" rows="2" v-model="order.externalMessage" maxlength="255"></TextInputField>

        <button
            :disabled="invalid || isDateConflict"
            class="btn-basic btn-green"
            @click="saveOrUpdate()">
          Opslaan
        </button>
        <button
            class="btn-basic btn-red"
            @click="cancelOrder()">
          Annuleren
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {ValidationObserver} from "vee-validate";
import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import TextInputField from "@/components/inputFields/TextInputField";
import {toDateMonthYear} from "@/util/DateUtil";

export default {
  name: "EditContractComponent",
  components: {
    DateInputField,
    NumberInputField,
    ValidationObserver,
    TextInputField
  },
  props: ["contractId", "from", "orderToEdit", "datesFromAllOrders"],
  data() {
    return {
      order: {
        startDate: "",
        endDate: "",
        baseHourlyRate: undefined,
        internalMessage: "",
        externalMessage: "",
      },
      orderOverlappedPeriods: []
    };
  },
  computed: {
    getTitleOfComponent() {
      return this.orderToEdit != null ? 'Order Aanpassen' : 'Nieuwe order toevoegen';
    },
    isDateConflict() {
      return (this.order.startDate && this.checkForDateConflict(this.order.startDate))
              || (this.order.endDate && this.checkForDateConflict(this.order.endDate));
    },
  },
  created() {
    this.initOrderToEdit();
  },
  methods: {
    ...mapActions("administrationContract", ['addHourlyRateToContract', "updateOrder"]),

    saveOrUpdate() {
      if (this.orderToEdit == null) {
        this.saveHourlyRate();
      }
      else {
        this.updateHourlyRate();
      }
    },
    saveHourlyRate() {
      const internalMessage = this.order.internalMessage === "" ? null : this.order.internalMessage;
      const externalMessage = this.order.externalMessage === "" ? null : this.order.externalMessage;
      const createOrderDto = {
          startDate: this.order.startDate,
          endDate: this.order.endDate,
          baseHourlyRate: this.order.baseHourlyRate,
          internalReference: internalMessage,
          externalReference: externalMessage
      };
      this.addHourlyRateToContract({
        contractId: this.contractId,
        createOrderDto,
        from: this.from
      });
      this.resetFields();
      this.$emit('hourlyRateAdded');
    },
    updateHourlyRate() {
      const internalMessage = this.order.internalMessage === "" ? null : this.order.internalMessage;
      const externalMessage = this.order.externalMessage === "" ? null : this.order.externalMessage;
      const updateOrderDto = {
        id: this.contractId,
        startDate: this.order.startDate,
        endDate: this.order.endDate,
        baseHourlyRate: this.order.baseHourlyRate,
        internalReference: internalMessage,
        externalReference: externalMessage
      };
      this.updateOrder(updateOrderDto);
      this.resetFields();
      this.$emit('hourlyRateUpdated');
    },
    cancelOrder() {
      this.resetFields();
      this.$emit('orderCanceled');
    },
    resetFields() {
      this.order.startDate = "";
      this.order.endDate = "";
      this.order.baseHourlyRate = undefined;
      this.order.internalMessage = "";
      this.order.externalMessage = "";
      this.orderOverlappedPeriods = [];
    },
    initOrderToEdit(){
      if (this.orderToEdit != null) {
        this.order.startDate = this.orderToEdit.startDate;
        this.order.endDate = this.orderToEdit.endDate;
        this.order.baseHourlyRate = this.orderToEdit.baseHourlyRate;
        this.order.internalMessage = this.orderToEdit.internalReference;
        this.order.externalMessage = this.orderToEdit.externalReference;
      }
    },
    checkForDateConflict(selectedDate) {
      this.orderOverlappedPeriods = [];
      if (this.datesFromAllOrders == null || this.datesFromAllOrders === []) {
        return false;
      }
      this.datesFromAllOrders.some(period => {
        const [startDateString, endDateString] = period.split(" Tot ");
        const startDate = new Date(startDateString);
        const endDate = new Date(endDateString);
        const selected = new Date(selectedDate);
        if (selected >= startDate && selected <= endDate) {
          this.orderOverlappedPeriods.push(toDateMonthYear(startDate) + " Tot " + toDateMonthYear(endDate));
        }
      });
      return this.orderOverlappedPeriods.length > 0;
    },

  },
};
</script>
<style scoped>

.bg-gray {
  background-color: #EEE;
}

</style>